import styled from "styled-components";
import { StyledHomePageContainer, StyledHomePageSectionBlock } from "../styledHomePage";
import { motion } from "framer-motion";

export const StyledHomePageAboutUsWrapper = styled(motion.div)`
  overflow: hidden;
  padding: 110px 0 60px;
  @media (max-width: 576px) {
    padding: 40px 0 0;
  }
`;

export const StyledHomePageAboutUsContainer = styled(StyledHomePageContainer)``;

export const StyledHomePageAboutUsBlock = styled(StyledHomePageSectionBlock)`
  position: relative;
  display: grid;
  grid-template-columns: minmax(100px, 618px) 1fr;
  align-items: center;
  z-index: 1;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledAboutUsContentInfo = styled.div`
  .main-title {
    &:before {
      content: "";
      width: 425px;
      height: 110px;
      position: absolute;
      top: -30px;
      left: -70px;
      background: rgba(23, 37, 160, 0.15);
      filter: blur(50px);
    }
  }

  @media (max-width: 576px) {
    margin: 0 auto;
    
    .main-title {
      font-size: 30px;
      text-align: center;

      &:before {
        width: 245px;
        height: 75px;
        top: -5px;
        left: 145px;
      }
    }

    .main-content {
      margin-top: 20px;
      font-size: 14px;
    }
  }
`;

export const StyledAboutUsContentImage = styled.div`
  height: 100%;
  position: relative;

  img {
    padding: 23px;
    height: auto;
    border: 1px solid #C1B2D7;
    border-radius: 15px;
    display: block;
    position: absolute;
    top: 0;
    transform: translateX(120px);
  }

  @media (max-width: 992px) {
    margin-top: 50px;
    height: auto;
    img {
      margin: 0 auto;
      height: 100%;
      width: 100%;
      max-width: 660px;
      position: relative;
      transform: none;
    }
  }
  @media (max-width: 768px) {
    margin-top: 30px;
    img {
      padding: 0;
      border: none;
    }
  }
  
`;